import React, {Fragment, useContext, useEffect, useState} from "react";
import LabelTradotta from "../LabelTradotta.jsx";
import NsDatePicker from "../NsDatePicker.jsx";
import NSSelectAutocomplete from "./NSSelectAutocomplete.jsx";
import NsFieldText from "./NsFieldText";
import NsFieldNumber from "./NsFieldNumber";
import NsFieldTreeSelect from "./NsFieldTreeSelect";
import NsFieldTextarea from "./NsFieldTextarea";
import NsFieldCheckbox from "./NsFieldCheckbox";
import NsFieldSelectbutton from "./NsFieldSelectbutton";
import {TranslateContext} from "../../context/TranslateContext";
import NsFieldPassword from "./NsFieldPassword";
import NSMultiSelect from "./NSMultiSelect.jsx";

export default function NsField({
                                    name,
                                    as = 'text',
                                    label = '',
                                    value = '',
                                    placeholder = '',
                                    formikRef,
                                    onChange = () => {
                                    },
                                    values = [],
                                    errors = [],
                                    submitCount,
                                    rows = 3,
                                    cols = 50,
                                    step = 1,
                                    valMaxNumeric = 999999999999999,
                                    maxFractionDigits = 0,
                                    showErrorMessage = true,
                                    showTimeInput = false,
                                    readOnly = false,
                                    isDisabled = false,
                                    isRequired = false,
                                    useGrouping = false,
                                    options = [],
                                    validate = () => {
                                    },
                                    valueTemplate = undefined,
                                    itemTemplate = undefined,
                                    maxDate = null,
                                    minDate = null,
                                    id = '',
                                    valoreNoFormik,
                                    type = '',
                                    isWidth100 = true,
                                    isMobile = false,
                                    isInModal = false,
                                    passwordFooter = "",
                                    passwordShowFeedback = false
                                }) {


    const [fieldType, setFieldType] = useState(as);
    const {translate} = useContext(TranslateContext);

    useEffect(() => {
        if (as && as !== '') {
            setFieldType(as);
        }
    }, [as]);

    const isFormFieldInvalid = () => {
        //let valido = errors[name] && touched[name] && submitCount > 0;
        let valido = errors[name] && submitCount > 0;
        return valido;
    };

    function getField() {
        let val = (formikRef && values && typeof values[name] !== 'undefined') ? values[name] : valoreNoFormik;
        if (typeof val === 'undefined') {
            val = '';
        }

        if (fieldType === 'text') {
            return (
                <NsFieldText
                    formikRef={formikRef}
                    type={type}
                    isDisabled={isDisabled}
                    onChange={onChange}
                    name={name}
                    isFormFieldInvalid={isFormFieldInvalid}
                    isRequired={isRequired}
                    value={val}
                    placeholder={placeholder}
                    validate={validate}
                    readOnly={readOnly}
                />
            );
        } else if (fieldType === 'number') {
            return (
                <NsFieldNumber
                    valMaxNumeric={valMaxNumeric}
                    useGrouping={useGrouping}
                    readOnly={readOnly}
                    onChange={onChange}
                    name={name}
                    formikRef={formikRef}
                    validate={validate}
                    placeholder={placeholder}
                    isRequired={isRequired}
                    isFormFieldInvalid={isFormFieldInvalid}
                    isDisabled={isDisabled}
                    valoreNoFormik={valoreNoFormik}
                    values={values}
                    step={step}
                    maxFractionDigits={maxFractionDigits}
                />
            );
        } else if (fieldType === 'select') {
            return (
                <NSSelectAutocomplete
                    name={name}
                    formikRef={formikRef}
                    options={options}
                    isDisabled={isDisabled}
                    onChangeSelect={onChange}
                    valueTemplate={valueTemplate}
                    itemTemplate={itemTemplate}
                    startVal={val}
                    placeholder={placeholder}
                    validate={validate}
                    invalid={isFormFieldInvalid()}
                    isInModal={isInModal}
                />
            );
        } else if (fieldType === 'multiselect') {
            return (
                <NSMultiSelect
                    name={name}
                    formikRef={formikRef}
                    startVal={val}
                    options={options}
                    onChangeSelect={onChange}
                    invalid={isFormFieldInvalid()}
                />
            );
        } else if (fieldType === 'treeselect') {
            return (
                <NsFieldTreeSelect
                    formikRef={formikRef}
                    validate={validate}
                    isFormFieldInvalid={isFormFieldInvalid}
                    isDisabled={isDisabled}
                    onChange={onChange}
                    name={name}
                    value={value}
                    placeholder={placeholder}
                    options={options}
                    isWidth100={isWidth100}
                />
            );
        } else if (fieldType === 'textarea') {
            return (
                <NsFieldTextarea
                    formikRef={formikRef}
                    validate={validate}
                    isFormFieldInvalid={isFormFieldInvalid}
                    isDisabled={isDisabled}
                    onChange={onChange}
                    name={name}
                    value={val}
                    readOnly={readOnly}
                    cols={cols}
                    rows={rows}
                />
            );
        } else if (fieldType === 'datepicker') {
            return (
                <NsDatePicker
                    name={name}
                    id={id}
                    showTimeInput={showTimeInput}
                    // se sono nel contesto di formik utilizzo i suoi valori, se no quello passato come prop
                    dataSelezionata={(formikRef && values[name]) ? new Date(values[name]) : valoreNoFormik}
                    setSelectedDate={onChange}
                    canBeDisabled={true}
                    className="form-control w-100"
                    autoComplete="off"
                    showTimeSelect={showTimeInput}
                    validate={validate}
                    invalid={isFormFieldInvalid()}
                    maxDate={maxDate}
                    minDate={minDate}
                    disabled={isDisabled}
                    placeholder={placeholder}
                />
            );
        } else if (fieldType === 'checkbox') {
            return (
                <NsFieldCheckbox
                    formikRef={formikRef}
                    validate={validate}
                    isFormFieldInvalid={isFormFieldInvalid}
                    isDisabled={isDisabled}
                    onChange={onChange}
                    name={name}
                    values={values}
                    valoreNoFormik={valoreNoFormik}
                    isRequired={isRequired}
                />
            );
        } else if (fieldType === 'mail') {
            return (
                <NsFieldText
                    formikRef={formikRef}
                    type={"mail"}
                    isDisabled={isDisabled}
                    onChange={onChange}
                    name={name}
                    isFormFieldInvalid={isFormFieldInvalid}
                    isRequired={isRequired}
                    value={val}
                    placeholder={placeholder}
                    validate={validate}
                    readOnly={readOnly}
                />
            );
        } else if (fieldType === 'selectbutton') {
            return (
                <NsFieldSelectbutton
                    formikRef={formikRef}
                    validate={validate}
                    isFormFieldInvalid={isFormFieldInvalid}
                    onChange={onChange}
                    name={name}
                    value={value}
                    isMobile={isMobile}
                    itemTemplate={itemTemplate}
                    options={options}
                    label={label}
                />
            );
        } else if (fieldType === 'password') {
            return (
                <NsFieldPassword
                    formikRef={formikRef}
                    validate={validate}
                    readOnly={readOnly}
                    onChange={onChange}
                    name={name}
                    value={val}
                    placeholder={placeholder}
                    isRequired={isRequired}
                    isFormFieldInvalid={isFormFieldInvalid}
                    isDisabled={isDisabled}
                    translate={translate}
                    passwordFooter={passwordFooter}
                    passwordShowFeedback={passwordShowFeedback}
                />
            );
        } else {
            return <Fragment/>
        }
    }

    return (
        fieldType && fieldType !== '' &&
        <Fragment>
            {
                label !== '' &&
                <LabelTradotta htmlFor={name}>{label}</LabelTradotta>
            }
            {
                getField()
            }
            {
                isFormFieldInvalid() && showErrorMessage === true &&
                <small className="p-error">{errors[name]}</small>
            }
        </Fragment>
    );
}